import React, { Component, Fragment } from 'react';
import { inject, observer } from 'mobx-react';
import b from 'b_';
import ConsoleStore from '../../stores/ConsoleStore';
import { DashboardStore } from '../../stores/DashboardStore';
import { ConsolePage, ConsolePageTitle } from '../ConsoleFragments';
import WidgetCounter from '../Widget/WidgetCounter';
import WidgetLineChart from '../Widget/WidgetLineChart';
import WidgetMultipleCounters from '../Widget/WidgetMultipleCounters';
import WidgetList from '../Widget/WidgetList';
import WidgetWrapper from './WidgetWrapper';
import FuseButton from '../FuseControls/FuseButton';
import FileDownloadModal from './FileDownloadModal';

import './Dashboard.css';

const block = b.lock('Dashboard');

class Dashboard extends Component {
    static propTypes = {
        dashboard: DashboardStore.PropType.isRequired,
        console: ConsoleStore.PropType.isRequired,
    };

    componentDidMount() {
        this.props.dashboard.update(this.props.console.onlyWebmail);
    }

    componentWillUnmount() {
        this.props.dashboard.stopUpdate();
    }

    getSummaryWidgets = () => {
        const { dashboard } = this.props;
        return [{
            title: 'TOTAL USERS',
            info: `The number of unique users that have used Proofpoint Isolation
                   at least one time. Auto-registration excluded.`,
            store: dashboard.activeUsers,
            exact: true,
        }, {
            title: 'TOTAL ENDPOINTS',
            info: 'The number of activated browsers used to connect to Proofpoint Isolation.',
            store: dashboard.activeEndpoints,
            exact: false,
        }, {
            title: 'THREAT-FREE DOMAINS DELIVERED',
            info: 'The number of unique domains (websites) requested for viewing.',
            store: dashboard.websitesDelivered,
            exact: false,
        }, {
            title: 'THREAT-FREE PAGES DELIVERED',
            info: 'The number of web pages (URLs) requested for viewing.',
            store: dashboard.pagesDelivered,
            exact: false,
        }];
    };

    getThreatWidgets = () => {
        const { dashboard } = this.props;
        return [{
            title: 'UPLOAD ATTEMPTS PREVENTED',
            info: 'The number of upload attempts detected by Proofpoint Isolation for all users',
            store: dashboard.counters.uploads,
        }, {
            title: 'DOWNLOAD ATTEMPTS PREVENTED',
            info: 'The number of downloads attempts detected by Proofpoint Isolation for all users',
            store: dashboard.counters.downloads,
        }, {
            title: 'ISOLATED JAVASCRIPT SOURCES',
            info: 'The number of external JavaScript sources removed by Proofpoint Isolation for all users',
            store: dashboard.counters.scripts,
        }];
    };

    render() {
        const { console, dashboard } = this.props;
        const reportDownload = dashboard.reportDownload;
        const isPPTEnabled = console.isMirrorFeatureEnabled('CREATE_PPT');
        return <ConsolePage>
            {isPPTEnabled && console.isSuperAdmin ?
                <Fragment>
                    <ConsolePageTitle className={block('TitleWrapper')}>
                        <span className={block('TitleText')}>
                            Dashboard - {console.onlyWebmail ? 'Email Isolation' : 'Browser Isolation'}
                        </span>
                        <FuseButton
                            type={FuseButton.type.PRIMARY}
                            color={FuseButton.color.BLUE}
                            icon={'material_download'}
                            onClick={reportDownload.openModal}
                            qa={'br-download-report'}
                        >Executive Report</FuseButton>
                    </ConsolePageTitle>
                </Fragment> : <ConsolePageTitle>
                    Dashboard - {console.onlyWebmail ? 'Email Isolation' : 'Browser Isolation'}
                </ConsolePageTitle>
            }
            <div className={block('Row')}>
                {this.getSummaryWidgets().map(({ title, info, store, exact }) => <WidgetWrapper key={title} size={25}>
                    <WidgetCounter
                        store={store}
                        exact={exact}
                        title={title}
                        infoTitle={title}
                        infoBody={info}
                    />
                </WidgetWrapper>)}
            </div>
            <ConsolePageTitle>Account Data</ConsolePageTitle>
            <div className={block('Row')}>
                <WidgetWrapper size={100}>
                    <WidgetLineChart
                        store={dashboard.usersAndEndpoints}
                        title="ACTIVE ENDPOINTS / USERS"
                        total1="Total Active Users"
                        legend1="Active Users"
                        total2="Total Active Endpoints"
                        legend2="Active Endpoints"
                    />
                </WidgetWrapper>
            </div>
            <ConsolePageTitle>Threat Data</ConsolePageTitle>
            <div className={block('Row')}>
                <WidgetWrapper size={100}>
                    <WidgetLineChart
                        store={dashboard.websitesAndPages}
                        title="THREAT-FREE CONTENT DELIVERED"
                        total1="Total Domains Delivered"
                        legend1="Domains Delivered"
                        total2="Total Pages Delivered"
                        legend2="Pages Delivered"
                    />
                </WidgetWrapper>
                {this.getThreatWidgets().map(({ title, info, store }) => <WidgetWrapper key={title} size={33}>
                    <WidgetMultipleCounters
                        title={title}
                        infoTitle={title}
                        infoBody={info}
                        store={store}
                        label="Total"
                        loading={dashboard.counters.updateState.isLoading}
                    />
                </WidgetWrapper>)}
            </div>
            <ConsolePageTitle>Activity Data</ConsolePageTitle>
            <div className={block('Row')}>
                <WidgetWrapper size={50}>
                    <WidgetList
                        store={dashboard.topSitesVisited}
                        title="TOP URLS VISITED"
                        indexTitle="Rank"
                        labelTitle="URL Visited"
                        valueTitle="Visited"
                    />
                </WidgetWrapper>
                <WidgetWrapper size={50}>
                    <WidgetList
                        store={dashboard.topSitesBlocked}
                        title="TOP URLS BLOCKED"
                        indexTitle="Rank"
                        labelTitle="URL Blocked"
                        valueTitle="Blocked"
                    />
                </WidgetWrapper>
            </div>
            <FileDownloadModal
                store={reportDownload}
            />
        </ConsolePage>;
    }
}

export default inject('dashboard', 'console')(observer(Dashboard));

